<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	title: 'Symposium Title',
	top: 'Symposium',
	headerImage: '/og.jpg',
	introduction: '',
	note: '',
}
const schema = defineSchema({
	title: $.text('Title'),
	top: $.text('Top Label'),
	headerImage: $.upload('Header Image'),
	introduction: $.richtext('Introduction', { basic: true }),
	note: $.text('Note Text'),
})
export const SymposiumHeader = defineBlock({
	pickerHidden: true,
	thumbnail: '/block-thumbs/SymposiumHeader.svg',
	category: 'Legacy',
	order: 410,
	name: 'SymposiumHeader',
	label: 'Symposium Header (Legacy)',
	icon: 'forum',
	schema,
	defaults,
})
</script>
<script setup lang="ts">

import { Btn, Image } from '@bagelink/vue'
import { ref } from 'vue'
import ArticleActions from '@/components/blocks/ArticleActions.vue'




defineProps<{
	title?: string
	top?: string
	headerImage?: string
	introduction?: string
	note?: string
}>()

const readMore = ref(false)
</script>

<template>
	<div class="w1100px py-1 m_w-100p m_pt-0">
		<div class="relative h-450px px-1 m_h-350px basicPrint">
			<div class="relative z-2 color-white mx-auto txt-center py-2 h100p flex column">
				<div class="mt-auto flex justify-content-center gap-1 pb-05">
					<div class="dashline-white w100px px-1" />
					<p class="txt17 light m_txt12">
						{{ top }}
					</p>
					<div class="dashline-white w100px px-1" />
				</div>
				<h1 class="txt28 regular my-0 m_txt20">
					{{ title }}
				</h1>
			</div>
			<div class="absolute z-1 gradient inset-0 w-100p h-100p" />
			<Image :src="headerImage" :alt="title" class="absolute inset-0 cover w-100p h-100p z-0" />
		</div>

		<div class="flex p-1 w720px mx-auto m_px-1 hidePrint">
			<ArticleActions class="ms-auto m_mx-auto hidePrint" />
		</div>
		<div
			v-if="introduction && introduction.length > 100"
			class="introduction-section w720px mx-auto m_px-1 pt-2"
			:class="{ maskReadMore: !readMore }"
		>
			<div class="txt17 m_txt15 sym-rtf" v-html="introduction" />
			<hr class="my-3 w-200px" />
			<p class="txt17 m_txt15">{{ note }}1</p>
		</div>
		<div v-if="!readMore && introduction && introduction.length > 100" class="txt-center pt-1">
			<Btn class="txt17 color-red" flat @click="readMore = !readMore"> Read More </Btn>
		</div>
	</div>
</template>
